import { render, staticRenderFns } from "./cta-link.vue?vue&type=template&id=d5ef3470&"
import script from "./cta-link.vue?vue&type=script&lang=js&"
export * from "./cta-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiIcon: require('/app/components/ui/icon.vue').default})
